<template>
  <span>
    <jt-data-table ref="table" class="jt-datatable no-shadow table_header consent_letter_table" v-bind="$props"
      @action-button="onActionButtonHandler" @selection="onSelectedUpdate">
      <template v-slot:header="{ props }">
        <q-tr :props="{ props }">
          <q-th v-if="!noneselect && !rowButtons" auto-width />
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            <div :class="handleCol({ col: col })">
            </div>
            {{ col.label }}
          </q-th>
          <q-th style="width: 1px" v-if="buttons.length > 0 && rowButtons" />
        </q-tr>
      </template>
      <template v-slot:body="{ props }">
        <q-tr :props="{ props }">
          <q-td v-if="!noneselect && !rowButtons" auto-width>
            <q-checkbox v-model="props.selected" color="primary" :id="props.row.id" />
          </q-td>
          <q-td v-for="col in props.cols" :key="col.name" :props="props">
            <span v-if="col.model === 'generator'">
              <div class="text-no-wrap">
                {{ props.row.generator }}
              </div>
              <span class="aditional-infos">
                {{ props.row.generatorDocument }}
              </span>
            </span>
            <span v-else-if="col.model === 'clientName'">
              <div class="text-no-wrap">
                {{ props.row.clientName }}
              </div>
              <span v-if="props.row.clientDocument" class="aditional-infos">
                {{ props.row.clientDocument }}
              </span>
            </span>
            <span v-else-if="!col.edit">
              {{ formatedValue(col) }}
            </span>
            <q-toggle v-else-if="col.type == 'CHECKBOX'" v-model="props.row[col.model]" />

            <span v-else>
              {{ props.row[col.model] }}
              <i class="fas fa-pencil-alt material-icons" />
              <q-popup-edit v-model="props.row[col.model]" auto-save>
                <jt-input v-model="props.row[col.model]" :type="col.type.toLowerCase()" :name="col.model" />
              </q-popup-edit>
            </span>
            <q-btn v-if="col.name === 'showhide'" flat round color="primary" class="q-mr-sm" :icon="props.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
      " @click="props.expand = !props.expand" />
          </q-td>
        </q-tr>
        <q-tr v-show="props.expand" :props="props">
          <q-td colspan="100%">
            <div class="row hidden-row">
              <div v-for="(col, key) in hiddenColumns" :key="key" class="col-6">
                <label>{{ col.label }}:</label>
                {{ props.row[col.model] }}
              </div>
            </div>
          </q-td>
        </q-tr>
      </template>
    </jt-data-table>
  </span>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable } from 'jtech-webcomps'

@Component({
  name: 'consentLetterDataTable',
  mixins: [JtDataTable],
  components: {},
  props: {
    id: String,
    interface: String,
    name: String
  }
}
)
export default class ConsentLetterDataTable extends Vue {
  handleCol ({ col }) {
    if (['generator'].includes(col.name)) {
      col.sortable = false
    }
  }
}
</script>
<style scoped lang="stylus">
@import '~quasar-variables';

.aditional-infos {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.05);
  font-size: 0.7rem
  padding 3px;
}

.consent_letter_table{
  height: 65vh !important;
}

.jt-datatable {
  .hidden-row > div {
    width: 100%;
    padding: 5px 12px;
  }

  .hidden-row > div:nth-child(odd) {
    background-color: $grey-3;
  }

  .q-table--no-wrap td {
    white-space: inherit !important;
  }
}
</style>
